import { combineReducers } from 'redux';
import { RootAction } from '@src/app/_redux';
import { OMS_LOOKUP_SUCCESS } from '@src/app/login/oms/actions';
import { PaymentMethod } from 'gc-backend';

export type State = {
  paymentMethods: Array<PaymentMethod> |  null;
};

export const reducer = combineReducers<State, RootAction>({
  paymentMethods: (state = [], action) => {
    switch (action.type) {
      case OMS_LOOKUP_SUCCESS:
        return action.payload.paymentMethods;
      default:
        return state;
    }
  },
});
